import React from 'react';
import {
  Box,
  Card,
  CardContent,
  IconButton,
  Modal,
  Typography,
} from '@mui/material';
import {
  Check as CheckIcon,
  Close as CloseIcon,
  FamilyRestroom as FamilyRestroomIcon,
} from '@mui/icons-material';
import { format } from 'rut.js';
import CustomButton from '../../../../components/General/CustomButton';
import { PersonInfo } from '../../types';
import useStyles from './styles';

interface LinkExistingRepresentativeModalProps {
  open: boolean;
  roleLabel: string;
  representative: PersonInfo | null;
  onClose: () => void;
  onConfirm: () => void;
}

function LinkExistingRepresentativeModal({
  open,
  roleLabel,
  representative,
  onClose,
  onConfirm,
}: LinkExistingRepresentativeModalProps) {
  const classes = useStyles();

  return (
    <Modal open={open} onClose={onClose}>
      <Box className={classes.modalContainer}>
        <Card className={classes.modal}>
          <CardContent className={classes.modalContent}>
            <Box className={classes.modalTitleContainer}>
              <Box className={classes.modalTitleAndIcon}>
                <FamilyRestroomIcon color="primary" />
                <Typography variant="h4" color="primary" fontWeight="bold">
                  Apoderado ya registrado
                </Typography>
              </Box>
              <IconButton onClick={onClose}>
                <CloseIcon color="primary" />
              </IconButton>
            </Box>
            <Box className={classes.modalBody}>
              <Typography variant="body1">
                {`El correo ingresado para el ${roleLabel} ya pertenece a un apoderado registrado:`}
              </Typography>
              {representative && (
                <Box className={classes.representativeInfo}>
                  <Typography variant="body1" fontWeight="bold">
                    {`${representative.user.name} ${representative.user.lastname}`}
                  </Typography>
                  <Typography variant="body2">
                    {`RUT: ${representative.rut ? format(representative.rut) : '-'}`}
                  </Typography>
                  <Typography variant="body2">
                    {`Correo: ${representative.user.email}`}
                  </Typography>
                  <Typography variant="body2">
                    {`Teléfono: ${representative.phoneNumber || '-'}`}
                  </Typography>
                </Box>
              )}
              <Typography variant="body1">
                {`¿Quieres vincularlo al alumno como ${roleLabel}? Se usarán sus datos registrados.`}
              </Typography>
            </Box>
            <Box className={classes.modalButtonsContainer}>
              <CustomButton
                text="Cancelar"
                colorType="tertiary"
                onClick={onClose}
                icon={<CloseIcon />}
              />
              <CustomButton
                text="Vincular apoderado"
                colorType="primary"
                onClick={onConfirm}
                icon={<CheckIcon />}
              />
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Modal>
  );
}

export default LinkExistingRepresentativeModal;
